import { render, staticRenderFns } from "./OrderReceivedPage.vue?vue&type=template&id=2dbb5f68"
import script from "./OrderReceivedPage.vue?vue&type=script&lang=js"
export * from "./OrderReceivedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports